"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactVirtualized = require("react-virtualized");
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _InputAdornment = _interopRequireDefault(require("@mui/material/InputAdornment"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _Popover = _interopRequireDefault(require("@mui/material/Popover"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _ArrowDropDownSharp = _interopRequireDefault(require("@mui/icons-material/ArrowDropDownSharp"));
var _Search = _interopRequireDefault(require("@mui/icons-material/Search"));
var _labelConsts = require("../../constants/labelConsts");
var _stringConsts = require("../../constants/stringConsts");
var _getDisplayName = _interopRequireDefault(require("../../logics/getDisplayName"));
var _stringUtil = _interopRequireDefault(require("../../logics/stringUtil"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const ITEM_MAX_DISP_ROWS = 8;
const ROW_HEIGHT = 42;
const INIT_LIST_WIDTH = 400;
const StyledPopover = (0, _styles.styled)(_Popover.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    '& .MuiPopover-paper': {
      margin: theme.spacing(1)
    }
  };
});
const StyledFormControl = (0, _styles.styled)(_FormControl.default, {
  shouldForwardProp: prop => prop !== '$highlight'
})(_ref2 => {
  let {
    theme,
    $highlight
  } = _ref2;
  return _objectSpread(_objectSpread({
    width: '100%'
  }, !!$highlight && {
    backgroundColor: 'rgba(0, 0, 0, 0.05)'
  }), {}, {
    '& .MuiInputBase-root.Mui-error': {
      backgroundColor: (0, _styles.alpha)(theme.palette.error.main, 0.12),
      borderRadius: 4
    }
  });
});
const StyledTextField = (0, _styles.styled)(_TextField.default, {
  shouldForwardProp: prop => prop !== '$highlight'
})(_ref3 => {
  let {
    theme,
    $highlight,
    disabled
  } = _ref3;
  return {
    width: '100%',
    '& .MuiInputBase-root': _objectSpread({
      paddingRight: 0,
      cursor: 'pointer'
    }, !!$highlight && {
      backgroundColor: 'rgba(0, 0, 0, 0.05)'
    }),
    '& .MuiInputBase-input': {
      paddingRight: 0,
      textOverflow: 'ellipsis',
      color: '#000000',
      cursor: disabled ? 'default' : 'pointer'
    },
    '& .MuiInputBase-input.Mui-disabled': {
      color: theme.palette.select.noneSelected
    }
  };
});
const NoneSelectedEm = (0, _styles.styled)('em')(_ref4 => {
  let {
    theme
  } = _ref4;
  return {
    color: theme.palette.select.noneSelected
  };
});
const SelectItems = (0, _styles.styled)('div', {
  shouldForwardProp: prop => prop !== '$notMatch'
})(_ref5 => {
  let {
    theme,
    $notMatch
  } = _ref5;
  return _objectSpread({
    maxHeight: 400,
    overflowY: 'hidden'
  }, !!$notMatch && {
    backgroundColor: theme.palette.select.notMatch,
    padding: theme.spacing(2)
  });
});
const SuggestText = (0, _styles.styled)(_TextField.default)({
  width: '97%'
});
const Item = (0, _styles.styled)(_MenuItem.default)(_ref6 => {
  let {
    theme
  } = _ref6;
  return {
    paddingTop: 0,
    paddingBottom: 0,
    '&.Mui-selected': {
      backgroundColor: theme.palette.action.selected
    }
  };
});

/**
 * @classdesc サジェストボックス部品
 * @prop {string} value - 選択された値
 * @prop {boolean} [setNone=true] - 「選択してください」の表示有無
 * @prop {string} [noneValue=''] - 「選択してください」の値
 * @prop {boolean} [setHyphen=false] - 「選択してください」を「－」で表示する
 * @prop {boolean} [disabled=false] - 非活性状態
 * @prop {fuction} onChange - 変更時のイベント
 * @prop {array} items - 選択肢のリスト
 * @prop {string} items.displayName - 選択肢の表示名
 * @prop {string} items.value - 選択肢の値
 * @prop {boolean} [incrementalSearch] - インクリメンタルサーチの有無
 * @prop {boolean} [error] - 入力エラー
 * @prop {string} [helperText] - エラーメッセージ
 */
class SuggestBox extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "initState", () => ({
      areaOpen: false,
      items: this.props.items,
      listItems: this.props.items,
      suggest: '',
      areaFocus: false,
      listWidth: INIT_LIST_WIDTH
    }));
    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (!_lodash.default.isEqual(prevProps.items, this.props.items)) {
        this.setState({
          items: this.props.items,
          listItems: this.props.items
        });
      }
    });
    _defineProperty(this, "handleAreaOpen", () => {
      this.setState({
        suggest: '',
        items: this.props.items,
        listItems: this.props.items
      });
    });
    _defineProperty(this, "handleAreaClose", () => {
      this.setState({
        areaOpen: false
      });
    });
    _defineProperty(this, "onSuggest", value => {
      this.setState({
        suggest: value,
        listItems: this.props.items.filter(item => {
          if (item.displayName) {
            return item.displayName.match(".*".concat(_stringUtil.default.escapeRegExp(value), ".*"));
          }
          return !Boolean(value);
        }).map(item => {
          let styledName;
          if (value) {
            const index = item.displayName.indexOf(value);
            styledName = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, item.displayName.substr(0, index), /*#__PURE__*/_react.default.createElement("u", null, value), item.displayName.substr(index + value.length));
          } else {
            styledName = item.displayName;
          }
          return _objectSpread(_objectSpread({}, item), {}, {
            displayName: item.displayName,
            styledName: styledName
          });
        })
      }, () => {
        if (this.itemList.current) {
          this.itemList.current.forceUpdateGrid();
        }
      });
    });
    _defineProperty(this, "isDispPleaseSelectRow", listItems => {
      return this.props.setNone && listItems.length === this.props.items.length;
    });
    _defineProperty(this, "displayName", (items, values) => {
      return (0, _getDisplayName.default)(items, values);
    });
    _defineProperty(this, "ListNumber", (items, value) => {
      var number = 1;
      if (value) {
        number = items.findIndex(item => item.value === value) + 1;
      }
      return number;
    });
    _defineProperty(this, "emptyLabel", () => {
      const {
        setHyphen,
        intl
      } = this.props;
      return setHyphen ? _stringConsts.STRING_CONSTS.HYPHEN_ZENKAKU : intl.formatMessage({
        id: _labelConsts.LABEL.CORE_PLEASE_SELECT
      });
    });
    _defineProperty(this, "calcListHeight", () => {
      const {
        listItems
      } = this.state;
      return Math.min(ITEM_MAX_DISP_ROWS, listItems.length) * ROW_HEIGHT + (this.isDispPleaseSelectRow(listItems) ? ROW_HEIGHT : 0);
    });
    _defineProperty(this, "rowRenderer", _ref7 => {
      let {
        key,
        index,
        style
      } = _ref7;
      const {
        listItems
      } = this.state;
      const {
        noneValue,
        onChange,
        value
      } = this.props;
      const isDispPleaseSelectRow = this.isDispPleaseSelectRow(listItems);
      if (isDispPleaseSelectRow && index === 0) {
        return /*#__PURE__*/_react.default.createElement(Item, {
          key: key,
          style: style,
          value: noneValue,
          onClick: () => {
            onChange(String(noneValue));
            this.handleAreaClose();
          }
        }, /*#__PURE__*/_react.default.createElement(NoneSelectedEm, null, this.emptyLabel()));
      } else {
        const item = listItems[index - (isDispPleaseSelectRow ? 1 : 0)];
        return /*#__PURE__*/_react.default.createElement(Item, {
          key: key,
          style: style,
          value: item.value,
          onClick: () => {
            onChange(String(item.value));
            this.handleAreaClose();
          },
          selected: item.value === value
        }, item.styledName ? item.styledName : item.displayName);
      }
    });
    _defineProperty(this, "highlight", focus => e => {
      this.setState({
        areaFocus: focus
      });
      e.target.setSelectionRange(0, 0);
    });
    this.state = this.initState();
    this.HOME_HELPER_TEXT_NAME = 'helperText';
    this.ADORNMENT_NAME = 'adornment';
    this.itemList = /*#__PURE__*/_react.default.createRef();
  }
  render() {
    const {
      intl,
      value,
      className,
      incrementalSearch,
      error,
      helperText
    } = this.props;
    const {
      items,
      listItems,
      suggest,
      listWidth,
      areaFocus,
      areaOpen
    } = this.state;
    const disabled = this.props.disabled || !this.props.items.length;
    const selectProps = {
      value: this.displayName(items, value),
      variant: 'outlined',
      placeholder: this.emptyLabel(),
      InputProps: {
        endAdornment: /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
          position: "end",
          name: this.ADORNMENT_NAME
        }, /*#__PURE__*/_react.default.createElement(_ArrowDropDownSharp.default, {
          color: "action"
        }))
      },
      inputProps: {
        readOnly: true
      },
      disabled: disabled,
      onClick: e => {
        if (this.HOME_HELPER_TEXT_NAME === e.target.getAttribute('name')) {
          return;
        }
        let parentElement = e.target.parentElement.parentElement;
        if (this.ADORNMENT_NAME === parentElement.getAttribute('name')) {
          parentElement = parentElement.parentElement.parentElement;
        }
        if (!disabled) {
          this.anchorEl = e.currentTarget;
          this.setState({
            areaOpen: true,
            listWidth: parentElement.clientWidth
          });
        }
      },
      FormHelperTextProps: {
        name: this.HOME_HELPER_TEXT_NAME
      },
      onFocus: this.highlight(true),
      onBlur: this.highlight(false),
      error: !!error,
      helperText: helperText
    };
    const number = this.ListNumber(items, value);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledFormControl, {
      className: className,
      $highlight: areaFocus || areaOpen
    }, /*#__PURE__*/_react.default.createElement(StyledTextField, selectProps)), /*#__PURE__*/_react.default.createElement(StyledPopover, {
      open: areaOpen,
      anchorEl: this.anchorEl,
      onClose: this.handleAreaClose,
      TransitionProps: {
        onEnter: this.handleAreaOpen
      }
    }, /*#__PURE__*/_react.default.createElement(SuggestText, {
      value: suggest,
      variant: "outlined",
      onChange: e => {
        const targetValue = e.target.value;
        if (incrementalSearch) {
          this.onSuggest(targetValue);
        } else {
          this.setState({
            suggest: targetValue
          });
        }
      },
      onKeyDown: e => {
        if (e.keyCode === 13) {
          this.onSuggest(suggest);
        }
      },
      InputProps: {
        endAdornment: /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
          position: "end"
        }, /*#__PURE__*/_react.default.createElement(_Search.default, {
          color: "action",
          onClick: () => this.onSuggest(suggest),
          style: {
            cursor: 'pointer'
          }
        })),
        placeholder: intl.formatMessage({
          id: _labelConsts.LABEL.CORE_PLEASE_ENTER_KEYWORD
        })
      }
    }), /*#__PURE__*/_react.default.createElement(SelectItems, {
      style: {
        width: listWidth
      },
      $notMatch: !listItems.length
    }, listItems.length ? /*#__PURE__*/_react.default.createElement(_reactVirtualized.List, {
      ref: this.itemList,
      width: listWidth,
      height: this.calcListHeight(),
      rowCount: listItems.length + (this.isDispPleaseSelectRow(listItems) ? 1 : 0),
      rowHeight: ROW_HEIGHT,
      rowRenderer: this.rowRenderer,
      scrollToIndex: number,
      scrollToAlignment: "center"
    }) : /*#__PURE__*/_react.default.createElement(_Typography.default, null, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_NO_ITEM_MATCH
    })))));
  }
}
_defineProperty(SuggestBox, "defaultProps", {
  setNone: true,
  noneValue: '',
  setHyphen: false,
  incrementalSearch: true
});
SuggestBox.propTypes = {
  value: _propTypes.default.string.isRequired,
  setNone: _propTypes.default.bool,
  noneValue: _propTypes.default.string,
  setHyphen: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onChange: _propTypes.default.func.isRequired,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    displayName: _propTypes.default.string.isRequired,
    value: _propTypes.default.string.isRequired
  })).isRequired,
  incrementalSearch: _propTypes.default.bool,
  error: _propTypes.default.bool,
  helperText: _propTypes.default.string
};
var _default = exports.default = (0, _reactIntl.injectIntl)(SuggestBox);